var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.theme === 'ANAUCO')?_c('img',{staticClass:"mx-auto",attrs:{"src":require("@/assets/images/logo/CyAnauco.png"),"alt":"login"}}):_c('img',{staticClass:"mx-auto",attrs:{"src":require("@/assets/images/logo/CyA.png"),"alt":"login"}})
}
var staticRenderFns = []

export { render, staticRenderFns }